import { supabase } from "~/integrations/supabase/client";
import {
  ClientCreditUnlockWithProfile,
  UnlockType,
} from "~/types/clientCreditUnlock";

export async function checkActiveUnlock(
  clientId: string,
  unlockType: UnlockType
): Promise<ClientCreditUnlockWithProfile | null> {
  const { data, error } = await supabase
    .from("client_credit_unlocks")
    .select(
      `
      *,
      unlocker_profile:profiles!client_credit_unlocks_unlocked_by_fkey(name, lastname)
    `
    )
    .eq("client_id", clientId)
    .eq("unlock_type", unlockType)
    .eq("is_active", true)
    .maybeSingle();

  if (error) {
    console.error("Error checking active unlock:", error);
    return null;
  }

  return data as ClientCreditUnlockWithProfile | null;
}

export async function createUnlock(
  clientId: string,
  unlockType: UnlockType,
  unlockedBy: string,
  reason?: string
): Promise<ClientCreditUnlockWithProfile | null> {
  const { data, error } = await supabase
    .from("client_credit_unlocks")
    .insert({
      client_id: clientId,
      unlock_type: unlockType,
      unlocked_by: unlockedBy,
      reason: reason || null,
    })
    .select(
      `
      *,
      unlocker_profile:profiles!client_credit_unlocks_unlocked_by_fkey(name, lastname)
    `
    )
    .single();

  if (error) {
    console.error("Error creating unlock:", error);
    throw new Error(error.message);
  }

  return data as ClientCreditUnlockWithProfile;
}

export async function revokeUnlock(
  unlockId: string,
  revokedBy: string
): Promise<void> {
  const { error } = await supabase
    .from("client_credit_unlocks")
    .update({
      is_active: false,
      revoked_by: revokedBy,
      revoked_at: new Date().toISOString(),
    })
    .eq("id", unlockId);

  if (error) {
    console.error("Error revoking unlock:", error);
    throw new Error(error.message);
  }
}

export async function getUnlockHistory(
  clientId: string
): Promise<ClientCreditUnlockWithProfile[]> {
  const { data, error } = await supabase
    .from("client_credit_unlocks")
    .select(
      `
      *,
      unlocker_profile:profiles!client_credit_unlocks_unlocked_by_fkey(name, lastname)
    `
    )
    .eq("client_id", clientId)
    .order("created_at", { ascending: false });

  if (error) {
    console.error("Error fetching unlock history:", error);
    return [];
  }

  return data as ClientCreditUnlockWithProfile[];
}
